// ACTIONS

// Loan Application
export const LOAN_APPLICATION_FETCH_START = 'loanApplicationFetchStart';
export const LOAN_APPLICATION_FETCH_SUCCESS = 'loanApplicationFetchSuccess';
export const LOAN_APPLICATION_FETCH_FAILURE = 'loanApplicationFetchFailure';

export const LOAN_APPLICATION_UPDATE_START = 'loanApplicationUpdateStart';
export const LOAN_APPLICATION_UPDATE_SUCCESS = 'loanApplicationUpdateSuccess';
export const LOAN_APPLICATION_UPDATE_FAILURE = 'loanApplicationUpdateFailure';

// Loan Application User
export const LOAN_APPLICATION_USER_GOTO_START = 'loanApplicationUserGotoStart';
export const LOAN_APPLICATION_USER_GOTO_SUCCESS = 'loanApplicationUserGotoSuccess';
export const LOAN_APPLICATION_USER_GOTO_FAILURE = 'loanApplicationUserGotoFailure';

export const LOAN_APPLICATION_USER_GOBACK_START = 'loanApplicationUserGobackStart';
export const LOAN_APPLICATION_USER_GOBACK_SUCCESS = 'loanApplicationUserGobackSuccess';
export const LOAN_APPLICATION_USER_GOBACK_FAILURE = 'loanApplicationUserGobackFailure';

export const LOAN_APPLICATION_USER_VERIFY_START = 'loanApplicationUserVerifyStart';
export const LOAN_APPLICATION_USER_VERIFY_SUCCESS = 'loanApplicationUserVerifySuccess';
export const LOAN_APPLICATION_USER_VERIFY_FAILURE = 'loanApplicationUserVerifyFailure';

// Financials
export const UPDATE_FINANCIALS_START = 'updateFinancialsStart';
export const UPDATE_FINANCIALS_SUCCESS = 'updateFinancialsSuccess';
export const UPDATE_FINANCIALS_FAILURE = 'updateFinancialsFailure';

// Income
export const UPDATE_INCOME_START = 'updateIncomeStart';
export const UPDATE_INCOME_SUCCESS = 'updateIncomeSuccess';
export const UPDATE_INCOME_FAILURE = 'updateIncomeFailure';

export const INCOME_SOURCE_CHANGED = 'incomeSourceChanged';
export const INCOME_EMPLOYER_TYPE_CHANGED = 'incomeEmployerTypeChanged';
export const BUILD_INCOME = 'buildIncome';
export const INCOME_CHANGED = 'incomeChanged';

export const INCOME_PREVIOUS_AMOUNT_CHANGED = 'incomePreviousAmountChanged';
export const INCOME_PAYG_TOGGLE_DETAILS = 'incomePaygToggleDetails'
export const INCOME_PAYG_EDIT_DETAILS = 'incomePaygEditDetails'

// Expenses
export const UPDATE_EXPENSE_START = 'updateExpenseStart';
export const UPDATE_EXPENSE_SUCCESS = 'updateExpenseSuccess';
export const UPDATE_EXPENSE_FAILURE = 'updateExpenseFailure';
export const PRIMARY_ENTERS_DATA_CHANGED = 'primaryEntersDataChanged';

// Loan Commitment
export const BUILD_COMMITMENT = 'buildCommitment';
export const COMMITMENT_CHANGED = 'commitmentChanged';
export const UPDATE_COMMITMENTS_START = 'updateCommitmentsStart';
export const UPDATE_COMMITMENTS_SUCCESS = 'updateCommitmentsSuccess';
export const UPDATE_COMMITMENTS_FAILURE = 'updateCommitmentsFailure';
export const CREDIT_HISTORY_CHANGED = 'creditHistoryChanged';

// Assets
export const BUILD_ASSET = 'buildAsset';
export const ASSET_CHANGED = 'assetChanged';
export const UPDATE_ASSETS_START = 'updateAssetsStart';
export const UPDATE_ASSETS_SUCCESS = 'updateAssetsSuccess';
export const UPDATE_ASSETS_FAILURE = 'updateAssetsFailure';

// Profile
export const UPDATE_PROFILE_START = 'updateProfileStart';
export const UPDATE_PROFILE_SUCCESS = 'updateProfileSuccess';
export const UPDATE_PROFILE_FAILURE = 'updateProfileFailure';

// Residential History
export const BUILD_RESIDENTIAL_HISTORY = 'buildResidentialHistory';
export const RESIDENTIAL_HISTORY_CHANGED = 'residentialHistoryChanged';
export const UPDATE_RESIDENTIAL_HISTORY_START = 'updateResidentialHistoryStart';
export const UPDATE_RESIDENTIAL_HISTORY_SUCCESS = 'updateResidentialHistorySuccess';

// Loan Detail
export const LOAN_DETAIL_CHANGED = 'loanDetailChanged';
export const UPDATE_LOAN_DETAIL_START = 'updateLoanDetailStart';
export const UPDATE_LOAN_DETAIL_SUCCESS = 'updateLoanDetailSuccess';
export const UPDATE_LOAN_DETAIL_FAILURE = 'updateLoanDetailFailure';
export const UPDATE_LOAN_DETAIL_CALCULATOR = 'updateLoanDetailCalculator';

// Loan Summary
export const UPDATE_LOAN_SUMMARY_START = 'updateLoanSummaryStart';
export const UPDATE_LOAN_SUMMARY_SUCCESS = 'updateLoanSummarySuccess';
export const UPDATE_LOAN_SUMMARY_FAILURE = 'updateLoanSummaryFailure';

// Employment
export const BUILD_EMPLOYMENT = 'buildEmployment';
export const EMPLOYMENT_CHANGED = 'employmentChanged';
export const UPDATE_EMPLOYMENTS_START = 'updateEmploymentsStart';
export const UPDATE_EMPLOYMENTS_SUCCESS = 'updateEmploymentsSuccess';
export const UPDATE_EMPLOYMENTS_FAILURE = 'updateEmploymentsFailure';

// Declaration
export const UPDATE_DECLARATION_START = 'updateDeclarationStart';
export const UPDATE_DECLARATION_SUCCESS = 'updateDeclarationSuccess';
export const UPDATE_DECLARATION_FAILURE = 'updateDeclarationFailure';

// Review
export const UPDATE_REVIEW_START = 'updateReviewStart';
export const UPDATE_REVIEW_SUCCESS = 'updateReviewSuccess';
export const UPDATE_REVIEW_FAILURE = 'updateReviewFailure';

// ReadyForFinal
export const UPDATE_READYFORFINAL_START = 'updateReadyForFinalStart';
export const UPDATE_READYFORFINAL_SUCCESS = 'updateReadyForFinalSuccess';
export const UPDATE_READYFORFINAL_FAILURE = 'updateReadyForFinalFailure';
